<template>
  <div class="bottom">
      
	  <div class="foottop">
		  <div class="concar f-row-l w-100">
			  <div class="f-row-l">
				<div class="lista f-row-c">
					<img src="../assets/footimga.png" />
				</div>
				<div class="listb f-row-c">
					<img src="../assets/footimgb.png" />
				</div>
			  </div>
			  <div class="f-row-start-b wr">
				  <div class="listc">
						<p>主办单位：{{informjson.unit}}</p>
						<p>地址：{{informjson.address}}</p>
						<p>传真：{{informjson.fax}}</p>
						<p>Copyright © 2012 All Rights Reserved. Designed</p>
						<p>技术支持：{{informjson.technology}}</p>
					
					</div>
					<div class="listd">
						<!-- <div>
							<img src="../assets/footimgc.png" />
						</div> -->
						<p class="name">直属机关纪委</p>
						<p class="a">举报邮箱:{{informjson.directlyEmail}}</p>
						<p class="b">举报电话:{{informjson.directlyPhone}}</p>
					</div>
					<div class="liste">
						<!-- <div>
							<img src="../assets/footimgd.png" />
						</div> -->
						<p class="name">纪检监察组</p>
						<p class="a">举报网址:{{informjson.inspectEmail}}</p>
						<p class="b">举报电话:{{informjson.inspectPhone}}</p>
					</div>
			  </div>
		  </div>
	  </div>
	  <div class="footbottom">
	  	 <span @click="navone">青海ICP备{{informjson.icpPrepare}}号</span>  
		 <img @click="navtwo" src="../assets/footimge.png" />
		 <span @click="navtwo">青公网安备{{informjson.publicPrepare}}号</span>  		 
	  </div>
	  
  </div>
</template>

<script>
export default {
  name: "foot",
  data() {
		return {
			informjson:{},
			
		};
  },
  
  created() {
  
  },
  
  mounted() {
	this.init();   
  },
  methods: {
	init() {
		  var that = this;
		  this.httpGet("web/statisticsController/getBottomConfig", {
				
		  }).then(res => {
				that.informjson = res.result;
				
		  });
	},
	
	navone() {
	   window.open("https://beian.miit.gov.cn/#/Integrated/index");
	},
	
	navtwo() {
	   window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001");
	}
	
	
  }
};
</script>

<style scoped lang="scss">
.bottom {
	  position: relative;
	  z-index: 5;
	.w-100{
		width: 100%;
	}
	.foottop{
		width: 100%;
		background: #434343;
		display: flex;
		align-items: center;
		justify-content: center;
		.f-row-c{
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.f-row-l{ 
			display: flex;
			align-items: center;
			align-content: center;
			justify-content: flex-start;
		}
		.f-row-b{
			display: flex;
			align-items: center;
			align-content: center;
			justify-content: space-between;
		}
		.f-row-start-b{
			display: flex;
			align-items: flex-start;
			align-content: flex-start;
			justify-content: space-between;
		}
		.concar{
			width: 1200px;
			display: flex;
			font-size: 14px;
			font-weight: 400;
			color: #FFFFFF;
			.wr{
				width: calc(100% - 266px);
			}
			.lista{
				img{
					width:62px;
					height:78px;
				}
			}			
			.listb{
				margin-left: 20px;
				margin-right:40px;
				img{
					width: 144px;
					height:51px;
				}
			}
			.listc{
				width: 380px;
				display: flex;
				flex-direction: column;
				justify-content: center;		
				margin-top: 40px;
				margin-bottom: 25px;
				p{
					line-height: 0.9;
					white-space:nowrap;
				}
				
			}
			
			.listd,.liste{	
				text-align: left;	
				img{
					width: 75px;
					height: 75px;
				}
				.name{
					font-size: 16px;
				}
				.a,.b{
					opacity: 0.5;
					line-height: 0.7;
					white-space:nowrap;
				}
			}
			.listd,.liste{
				margin-top: 35px;
			}
			.liste{
				margin-left: 20px;
				display: flex;
				flex-direction: column;
				align-items: left;
				justify-content: center;
			}
		}
	}
		 
	.footbottom{
		width: 100%;
		height: 41px;
		line-height: 41px;
		text-align: center;
		background: #1B1B1B;
		font-size: 12px;
		font-weight: 400;
		color: #FBFBFB;
		img{
			height: 18px;
			width: 18px;
			margin-top: 5px;
			margin-left:40px;
			margin-right:5px;
			cursor: pointer;			
		}
		span{
			opacity: 0.5;
			cursor: pointer;
		}
	}
}

</style>
